import { orderConstants } from "../_constants";

const initialState = {
    data: [],
    loading: false
}

export function order(state = initialState, action) {
    switch (action.type) {
        case orderConstants.ORDER_LOADING:
            return {
                ...state,
                loading: true,
                data: []
            };
        case orderConstants.ORDER_LOADED:
            return {
                ...state,
                loading: false,
                data: action.data
            };
        case orderConstants.ORDER_ERROR:
            return {
                ...state,
                loading:false,
                data: []
            };
        default:
            return state;
    }
}